import { Input, Modal, Table, Tag } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setSearchSlice } from '../../../store/slices/searchSlice'
import { remainingViewportHeight } from '../../icons/ApplicationColor'
import Axios from "../../../api/Axios";
import {
  // EditOutlined,
  DeleteTwoTone,
  CloseOutlined,
  CheckOutlined,
  SwapOutlined,
} from "@ant-design/icons";

const UserSearch = (isModalOpen) => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]);


  // renderes for ant design which renders the roles, the condition is there because there was instances of one user having multiple user
  // roles
  const renderRoles = (text, record) => {
    const role = record?.roles.map((role, index) =>  index < 1 ?  role.key_name === "client_user" ? "User" : "Admin" : "")
    return (
      <Tag color="blue">{role}</Tag>
    )
    
  }
  // status renderer for active, this is in many files
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };

  // columns for antdesign which we useon the table
  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 150,
    },
    {
      title: "Full Name",
      dataIndex: "full_name",
      key: "full_name",
      width: 200,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 300,
    },
    {
      title : "Client Name",
      dataIndex : "client_name",
      key : "client_name",
      width : 200,
    },
    {
      title : "Client ID",
      dataIndex : "client_id",
      key : "client_id",
      width : 100,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus,
      width: 100,

    },
    {
      title : "Roles",
      dataIndex : "roles",
      key : "roles",
      render : renderRoles,
      width: 100,
    }
  ];
  
    const handleModalCancel = () => {
  
      console.log("IN MODAL CANCEL")
        dispatch(
          setSearchSlice({
            isModalVisible : false
          })
        )
    }

  const  onInput = async (input) => {
    await Axios.get(`/userserach/?page=1&page_size=10&search=${input}`).then((res)=>setData(res.data.results), setLoading(false)).catch((err)=>console.log(err))
  }

  return (
    <Modal title="Search" width={1300}
            open={isModalOpen.isModalOpen} onOk={() => console.log("ONOK")} onCancel={handleModalCancel}
            footer={[
             <></>
            ]}>
      <div style={{
        display : 'flex',
        flexDirection : 'column',
        alignItems : 'center',
        justifyContent : 'center',
        overflow : 'clip'
        
      }}>
        <Input placeholder="Seach Users" style={{
          width : "1240px"
        }}
        onInput={(event)=>{onInput(event.target.value)}}
        />
          <Table
          columns={columns}
          dataSource={data}
          size="middle"
          loading={loading}
          bordered
          rowKey="id"
          scroll={{
            x: 500,
            y: `${remainingViewportHeight(24)}px`,
          }}
          pagination={false}
          className="table-container"
          style={{ margin: "0.5rem" }}
        />

      </div>

    
      </Modal>
  )
}

export default UserSearch